<template>
  <v-container grid-list-md fluid>
    <v-layout row wrap style="margin-top: 150px;">
      <v-btn
        style="position: absolute; top: -35px; right: 20px;"
        @click="print"
        fab
        dark
        small
        color="primary"
        class="hidden-print-only"
      >
        <v-icon>mdi-printer</v-icon>
      </v-btn>
    <v-flex xs12 style="margin-top: 6.5cm;"></v-flex>

      <v-flex xs12 class="text-xs-center mb-4">
        <div class="title mb-1">Patient Payments</div>
        <div>{{new Date().toISOString() | moment('YYYY-MM-DD h:mm:ss A')}}</div>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap class="grey lighten-2 px-2">
          <v-flex xs6 sm3 class="text-capitalize">
            <strong>Patient ID:</strong>
            {{summary.serial}}
          </v-flex>

          <v-flex xs6 sm3 class="text-capitalize">
            <strong>Patient Name:</strong>
            {{summary.name}}
          </v-flex>

          <v-flex xs6 sm3>
            <strong>Age:</strong>
            {{summary.age}}
          </v-flex>

          <v-flex xs6 sm3 class="text-capitalize">
            <strong>Gender:</strong>
            {{summary.gender}}
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 mt-2>
        <v-data-table :headers="headers" :items="summary.items" hide-actions>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.payable_type | type }}</td>
            <td>{{ props.item.amount }}</td>
            <td>{{ props.item.date | moment('YYYY-MM-DD') }}</td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  layout: "print",
  computed: {
    summary() {
      return this.$store.getters["patients/currentSummary"];
    }
  },
  data() {
    return {
      headers: [
        { text: "#", value: "id", sortable: false },
        { text: "Type", value: "type", sortable: false },
        { text: "Amount(AFN)", value: "amount", sortable: false },
        { text: "Date", value: "date", sortable: false }
      ]
    };
  },
  filters: {
    type: function(value) {
      const map = {
        patient_test: "Lab Test Fee",
        patient_procedure: "Procedure Fee",
        prescriptions: "Prescription Total",
        appointments: "Appointment Fee"
      };

      return map[value];
    }
  },
  methods: {
    print() {
      window.print();
    }
  },
  mounted() {
    this.print();
  }
};
</script>

<style lang="scss" scoped>
</style>